<template>
  <div>
    <div flex v-for="(item, index) in optionsList" :key="index" class="option-item">

      <div v-if="showTitle" style="margin-right: 2px;" class="questionSeq">{{ sortString[index] }}</div>
      <bc-view-common flex-box="1"
                      :border="false"
                      :content="item.content"
                      :fileInfo="item.fileInfo"
      ></bc-view-common>
    </div>
  </div>
</template>

<script>
let sortString = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'

export default {
  name: 'bc-sort-question-view',
  props: {
    option: {
      type: [String, Array],
      default: ''
    },
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      optionsList: [],
      sortString: sortString.split('')
    }
  },
  watch: {
    option: {
      handler(val) {
        try {
          if (Array.isArray(val)) {
            this.optionsList = val
          } else {
            this.optionsList = JSON.parse(val)
          }
        } catch (err) {
          this.optionsList = []
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped lang="scss">
.option-item + .option-item {
  margin-top: 16px;
}

.option-item {
  background: #FBFBFB;
  border-radius: 6px;
  padding-left: 16px;
  ::v-deep .stem-content {
    &.no-border {
      padding: 8px 14px !important;
    }
  }
}
</style>
